import { InteriorType } from "@1games-ru/region-shared/dist/enums/interior/interior";
import { useCallback, useState } from "react";
import EstateMpProvider from "@/core/data-provider/data-mp/estate/estate-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";

export default function useGetInteriors(type: InteriorType | null = null) {
  const [isPending, setIsPending] = useState(false);

  const getInteriors = useCallback(async () => {
    setIsPending(true);
    const response = await EstateMpProvider.getInteriors(type);
    if (response instanceof RpcMpProviderFailedResponse) {
      setIsPending(false);
      console.error(response);
      throw new Error("getInteriors - EstateMpProvider.getInteriors() error");
    }

    setIsPending(false);

    return response.data;
  }, [type]);

  return { isPending, getInteriors };
}
